import React, { useCallback } from 'react';

import { RecurringMeeting } from 'Shared/constants/types';

import ContentWrapper from '../Wrappers/ContentWrapper/ContentWrapper';
import { WorkspacesType } from '../../types';
import FormFields from './FormFields/FormFields';
import { outputWorkspacesDecorator, getInitialRecurringMeetings, getInitialWorkspaces } from './utils';

import './OneOnOneWorkspacesFromCalendar.scss';

type Props = {
  workspaces: WorkspacesType;
  advanceOnboardingState: Function;
  recurringMeetings: Array<RecurringMeeting>;
};

const formValidate = values => {
  if (
    (values.workspaces && values.workspaces.some(item => item.selected && item.fullName)) ||
    values.recurringMeetings.some(({ selected }) => selected)
  )
    return {};
  return { error: 'Required field' };
};

function OneOnOneWorkspacesFromCalendar({
  workspaces: initWorkspaces,
  recurringMeetings: initRecurringMeetings,
  advanceOnboardingState,
}: Props) {
  const handleNextStep = useCallback(
    ({ workspaces, recurringMeetings }) => {
      return advanceOnboardingState({
        workspaces: outputWorkspacesDecorator({
          workspaces: workspaces.filter(({ selected, recurring_meeting_uuid }) => recurring_meeting_uuid || selected),
          recurringMeetings,
        }),
      });
    },
    [advanceOnboardingState]
  );

  return (
    <ContentWrapper
      initialValues={{
        workspaces: getInitialWorkspaces({ initWorkspaces }),
        recurringMeetings: getInitialRecurringMeetings({ initRecurringMeetings, initWorkspaces }),
      }}
      formValidate={formValidate}
      title="Create 1:1 Workspaces"
      description={
        <>
          We found these <b>1:1’s</b> in your calendar. Select them to create meeting workspaces. We won’t invite your
          teammates yet.
        </>
      }
      mutedDescription
      onNextStep={handleNextStep}
    >
      <FormFields />
    </ContentWrapper>
  );
}

export default OneOnOneWorkspacesFromCalendar;
